import * as TYPES from "./types";
import {IHeaderSettings} from "@/store/modules/layout/interfaces";

export default {
    [TYPES.SET_HEADER_SETTINGS](state: any, payload: IHeaderSettings) {
        state.header = payload;
    }
}